export default __webpack_public_path__ + "static/media/alarm.e480e98a.svg";